import { dispatchTypes } from '../actions';
import { Reducer } from 'redux';
import { AnyAction } from 'redux';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const accountReducer: Reducer<any, AnyAction> = (state = {}, action) => {
  const account = action.account;
  switch (action.type) {
    case dispatchTypes.COMMON.UPDATEACCOUNT:
      return { ...state, ...account };
    case dispatchTypes.COMMON.UPDATEFIELD:
      return {
        ...state,
        ...{
          ...state.account,
          [action.field]: action.value,
        },
      };
    case dispatchTypes.COMMON.UPDATEBIODETAILS:
      return { ...state, ...{ ...action.account } };
    case dispatchTypes.BUSINESS.THEME_INTERNAL.UPDATE_FIELDS:
      return {
        ...state,
        theme: {
          ...state.theme,
          themeInternal: {
            ...state.theme?.themeInternal,
            ...action.payload,
          },
        },
      };
    default:
      return state;
  }
};

export default accountReducer;
